import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { images } from '../../data/content';
const pathway = ['You’ll begin with the electrical foundations of the heart.', 'Then explore common rhythm patterns.', 'Practice a structured approach to reviewing ECG tracings.', 'Study 12-lead ECG concepts.', 'Examine common interpretation pitfalls.', 'And reinforce your learning with simulated cases.'];
export function Educator() {
  return <section className="bg-white px-5 py-16 md:py-24" aria-labelledby="educator-title" data-id="element-141" data-mp="17rr826zbh7fy">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-16" data-id="element-142" data-mp="12vjzs7jg7juu">
        <div className="lg:sticky lg:top-8 lg:self-start" data-id="element-143" data-mp="yv9vczbb11i3">
          <img src={images.rachel} alt="Rachel Bennett, Critical Care Nursing Educator, in an ICU" className="-mx-5 w-[calc(100%+2.5rem)] max-w-none object-cover sm:mx-0 sm:w-full sm:rounded-3xl" data-id="element-144" data-mp="tt12e2yflzfz" />
        </div>

        <div data-id="element-145" data-mp="30eq5blg7ej3y">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-146" data-mp="30e81o3r7p2m0">
            Meet the educator
          </p>
          <h2 id="educator-title" className="mt-3 font-display text-4xl font-black leading-tight text-navy-900 sm:text-5xl" data-id="element-147" data-mp="35d1erv2l6rln">
            Hi, I’m Rachel Bennett
          </h2>
          <p className="mt-2 text-lg font-bold text-pulse-600" data-id="element-148" data-mp="2wbtifijms0u7">Critical Care Nursing Educator</p>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink" data-id="element-149" data-mp="2hngkwh4wa9xl">
            <p data-id="element-150" data-mp="2mf8d0w3p8npu">
              ECG interpretation brings together several important concepts: cardiac electrical activity, heart rate
              and rhythm, waveforms and intervals, conduction patterns, 12-lead fundamentals, and the clinical context
              surrounding each tracing.
            </p>
            <p data-id="element-151" data-mp="1yp4cixlt5432">
              When these topics are scattered across different textbooks, lecture notes, and reference charts, studying
              them can become unnecessarily complicated.
            </p>
            <p className="rounded-2xl bg-navy-900 p-5 font-display text-xl font-extrabold leading-snug text-white" data-id="element-152" data-mp="99aatswl0f3m">
              Organize the fundamentals first. Build connections between concepts. Then reinforce understanding through
              structured practice.
            </p>
            <p data-id="element-153" data-mp="3rn17s92j6j2q">That’s why this collection is arranged into six complementary learning volumes.</p>
          </div>

          <ol className="mt-6 space-y-3" data-id="element-154" data-mp="s5tgu9c39mvy">
            {pathway.map((step, i) => <li key={step} className="flex items-start gap-3 text-[16px] font-semibold text-ink" data-id="element-155" data-mp="o59gkww7y35l" data-mpi={i}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-pulse text-sm font-black text-white" data-id="element-156" data-mp="j5dex4azunt7">
                  {i + 1}
                </span>
                <span className="pt-0.5" data-id="element-157" data-mp="33x6w3uty70k2">{step}</span>
              </li>)}
          </ol>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink" data-id="element-158" data-mp="2yx17kniz5u67">
            <p data-id="element-159" data-mp="2otno2hll77pp">
              My intention is not to suggest that a digital educational resource can replace clinical training or
              professional judgment. Instead, I want this collection to serve as an organized reference you can return
              to as you continue developing your understanding of electrocardiography.
            </p>
            <p data-id="element-160" data-mp="33k37prycu7lr">
              Whether you’re beginning your ECG studies or reviewing concepts you’ve encountered before, I hope these
              materials help make your learning process more structured and purposeful.
            </p>
            <p className="font-display text-xl font-extrabold text-navy-900" data-id="element-161" data-mp="3cl1bc94vsd3t">— Rachel Bennett</p>
          </div>

          <div className="[&>div]:items-start" data-id="element-162" data-mp="3mh4ftln7gntx">
            <SectionCTA label="Yes! I want to study with Rachel’s ECG Blueprint™" data-id="element-163" data-mp="3mgw1dpbfpagm" />
          </div>
        </div>
      </div>
    </section>;
}